module.exports = __webpack_public_path__ + "static/gubretas1-96c483710047dae8f02a0af89f3ed2c7.png";